import Alpine from "alpinejs";

Alpine.data("countdown", () => ({
    endDate: '2026-12-05',
    endTime: '00:00:00',
    remainingTime: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    timer: null,
    timezone: "UTC", // Default timezone
    finishedText: '',

    numbersSizeDesktop: '36',
    numbersSizeTablet: '36',
    numbersSizeMobile: '36',
    numbersColor: '',

    numbersStyle: '',

    daysText: '',
    hoursText: '',
    minutesText: '',
    secondsText: '',

    labelsSizeDesktop: '',
    labelsSizeTablet: '',
    labelsSizeMobile: '',
    labelsColor: '',

    labelsStyle: '',

    separatorStyle: 'colon',
    separatorColor: '',
    separatorSizeDesktop: '',
    separatorSizeTablet: '',
    separatorSizeMobile: '',
    desktopWidth: '',
    tabletWidth: '',
    mobileWidth: '',
    desktopHeight: '',
    tabletHeight: '',
    mobileHeight: '',

    colonSeparatorStyle: '',
    lineSeparatorStyle: '',

    textPosition: 'below',
    leadingZero: false,
    hideDays: false,

    init() {
        this.calculateEndDate();
        this.start();

        let self = this;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-countdownSettings') {
                self.changeSettings(event.data.data);
            }
        });

        this.updateNumbersStyle();
        // Add listeners for each media query
        const mediaQueries = [
            '(max-width: 767px)',
            '(min-width: 768px) and (max-width: 1024px)',
            '(min-width: 1025px)'
        ];
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.updateNumbersStyle.bind(this))
        );

        this.updateLabelsStyle();
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.updateLabelsStyle.bind(this))
        );

        this.updateColonStyle();
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.updateColonStyle.bind(this))
        );

        this.updateLineStyle();
        mediaQueries.forEach(query =>
            window.matchMedia(query).addEventListener('change', this.updateLineStyle.bind(this))
        );
    },

    calculateEndDate() {
        const dateString = this.endDate + "T" + this.endTime + 'Z';
        const utcDate = new Date(dateString);

        // Convert to the desired timezone
        const options = { timeZone: this.timezone, hourCycle: "h23" };
        const formatter = new Intl.DateTimeFormat("en-US", {
            ...options,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });

        const parts = formatter.formatToParts(utcDate);
        const year = parseInt(parts.find((part) => part.type === "year").value, 10);
        const month = parseInt(parts.find((part) => part.type === "month").value, 10) - 1;
        const day = parseInt(parts.find((part) => part.type === "day").value, 10);
        const hour = parseInt(parts.find((part) => part.type === "hour").value, 10);
        const minute = parseInt(parts.find((part) => part.type === "minute").value, 10);
        const second = parseInt(parts.find((part) => part.type === "second").value, 10);

        // Create a new date object for the adjusted time
        this.endDate = new Date(Date.UTC(year, month, day, hour, minute, second));
    },

    start(data) {
        if (data) {
            this.timezone = data.timezone;
            this.finishedText = data.finishedText;
            this.endDate = data.finishingDate;
            this.endTime = data.finishingTime;

            this.numbersSizeDesktop = data.numbersSizeDesktop;
            this.numbersSizeTablet = data.numbersSizeTablet;
            this.numbersSizeMobile = data.numbersSizeMobile;
            this.numbersColor = data.numbersColor;

            this.daysText = data.daysText;
            this.hoursText = data.hoursText;
            this.minutesText = data.minutesText;
            this.secondsText = data.secondsText;

            this.labelsSizeDesktop = data.labelsSizeDesktop;
            this.labelsSizeTablet = data.labelsSizeTablet;
            this.labelsSizeMobile = data.labelsSizeMobile;
            this.labelsColor = data.labelsColor;

            this.separatorStyle = data.separatorStyle;
            this.separatorColor = data.separatorColor;
            this.separatorSizeDesktop = data.separatorSizeDesktop;
            this.separatorSizeTablet = data.separatorSizeTablet;
            this.separatorSizeMobile = data.separatorSizeMobile;
            this.desktopWidth = data.desktopWidth;
            this.tabletWidth = data.tabletWidth;
            this.mobileWidth = data.mobileWidth;
            this.desktopHeight = data.desktopHeight;
            this.tabletHeight = data.tabletHeight;
            this.mobileHeight = data.mobileHeight;

            this.textPosition = data.textPosition;
            this.leadingZero = data.leadingZero === 'true';
            this.hideDays = data.hideDays === 'true';

            this.calculateEndDate();
            this.update();
            this.updateNumbersStyle();
            this.updateLabelsStyle();
            this.updateColonStyle();
            this.updateLineStyle();
            this.timer = setInterval(() => this.update(), 1000);
        }
    },

    update() {
        const now = Date.now();
        this.remainingTime = this.endDate - now;

        if (this.remainingTime <= 0) {
            this.remainingTime = 0;
            clearInterval(this.timer);

            this.days = "00";
            this.hours = "00";
            this.minutes = "00";
            this.seconds = "00";
        } else {
            if (this.hideDays) {
                // Calculate total hours, including days
                const totalHours = Math.floor(this.remainingTime / (1000 * 60 * 60));
                this.hours = totalHours.toString().padStart(this.leadingZero ? 2 : 1, "0");

                this.minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60))
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");

                this.seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000)
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");
            } else {
                // Show days, hours, minutes, and seconds
                this.days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24))
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");

                this.hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");

                this.minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60))
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");

                this.seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000)
                    .toString()
                    .padStart(this.leadingZero ? 2 : 1, "0");
            }


        }
    },

    changeTimezone(newTimezone) {
        this.timezone = newTimezone;
        this.calculateEndDate(); // Recalculate with the new timezone
        this.update(); // Update countdown immediately
    },

    changeSettings(data) {
        let json = JSON.parse(data);

        this.endDate = json.finishingDate;
        this.endTime = json.finishingTime??this.endTime;
        this.timezone = json.timezone;
        this.finishedText = json.finishedText;

        this.numbersColor = json.numbersColor;
        this.numbersSizeDesktop = json.numbersSizeDesktop;
        this.numbersSizeTablet = json.numbersSizeTablet;
        this.numbersSizeMobile = json.numbersSizeMobile;

        this.daysText = json.daysText;
        this.hoursText = json.hoursText;
        this.minutesText = json.minutesText;
        this.secondsText = json.secondsText;

        this.labelsColor = json.labelsColor;
        this.labelsSizeDesktop = json.labelsSizeDesktop;
        this.labelsSizeTablet = json.labelsSizeTablet;
        this.labelsSizeMobile = json.labelsSizeMobile;

        this.separatorStyle = json.separatorStyle;
        this.separatorColor = json.separatorColor;
        this.separatorSizeDesktop = json.separatorSizeDesktop;
        this.separatorSizeTablet = json.separatorSizeTablet;
        this.separatorSizeMobile = json.separatorSizeMobile;
        this.desktopWidth = json.desktopWidth;
        this.tabletWidth = json.tabletWidth;
        this.mobileWidth = json.mobileWidth;
        this.desktopHeight = json.desktopHeight;
        this.tabletHeight = json.tabletHeight;
        this.mobileHeight = json.mobileHeight;

        this.textPosition = json.textPosition;
        this.leadingZero = json.leadingZero;
        this.hideDays = json.hideDays;

        this.calculateEndDate();
        this.update();
        this.updateNumbersStyle();
        this.updateLabelsStyle();

        if (this.separatorStyle === 'colon') {
            this.updateColonStyle();
        }

        if (this.separatorStyle === 'line') {
            this.updateLineStyle();
        }
    },

    updateNumbersStyle() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.numbersStyle = 'font-size: ' + this.numbersSizeMobile + 'px;';
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.numbersStyle = 'font-size: ' + this.numbersSizeTablet + 'px;';
        } else {
            // Styles for desktop screens
            this.numbersStyle = 'font-size: ' + this.numbersSizeDesktop + 'px;';
        }

        this.numbersStyle = this.numbersStyle + 'color: ' + this.numbersColor + ';';
    },

    updateLabelsStyle() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.labelsStyle = 'font-size: ' + this.labelsSizeMobile + 'px;';
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.labelsStyle = 'font-size: ' + this.labelsSizeTablet + 'px;';
        } else {
            // Styles for desktop screens
            this.labelsStyle = 'font-size: ' + this.labelsSizeDesktop + 'px;';
        }

        this.labelsStyle = this.labelsStyle + 'color: ' + this.labelsColor + ';';
    },

    updateColonStyle() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.colonSeparatorStyle = 'font-size: ' + this.separatorSizeMobile + 'px;';
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.colonSeparatorStyle = 'font-size: ' + this.separatorSizeTablet + 'px;';
        } else {
            // Styles for desktop screens
            this.colonSeparatorStyle = 'font-size: ' + this.separatorSizeDesktop + 'px;';
        }

        this.colonSeparatorStyle = this.colonSeparatorStyle + 'color: ' + this.separatorColor + ';';
    },

    updateLineStyle() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            // Styles for mobile screens
            this.lineSeparatorStyle = 'width: ' + this.mobileWidth + 'px; height: ' + this.mobileHeight + 'px;' ;
        } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
            // Styles for tablet screens
            this.lineSeparatorStyle = 'width: ' + this.tabletWidth + 'px; height: ' + this.tabletHeight + 'px;' ;
        } else {
            // Styles for desktop screens
            this.lineSeparatorStyle = 'width: ' + this.desktopWidth + 'px; height: ' + this.desktopHeight + 'px;' ;
        }

        this.lineSeparatorStyle = this.lineSeparatorStyle + 'background: ' + this.separatorColor + ';';
    }
}));
